/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

import React from "react";
import {
  Smartphone,
  Server,
  Monitor,
  Sparkles,
} from "lucide-react";

const items = [
  {
    title: "Orion Mobile",
    icon: Smartphone,
    description:
      "The complete Orion Analytics experience optimized for mobile devices with synchronized watchlists, analytics and research.",
  },

  {
    title: "Orion Developer APIs",
    icon: Server,
    description:
      "Market analytics, screening data, signals and financial intelligence services accessible through APIs for developers and traders.",
  },

  {
    title: "Advanced Research Workspace",
    icon: Monitor,
    description:
      "A future desktop-focused experience designed for intensive market research and professional analytics workflows.",
  },
];

const SoftwareComingSoon = () => {
  return (
    <section className="py-24 px-6 lg:px-10 bg-white">

      <div className="max-w-7xl mx-auto">

        <div className="mb-12">

          <div
            className="
              text-sm
              uppercase
              tracking-[0.3em]
              text-blue-700
              font-bold
              mb-4
            "
          >
            Future Products
          </div>

          <h2
            className="
              text-4xl
              lg:text-5xl
              font-black
              mb-4
            "
          >
            Coming Soon
          </h2>

          <p
            className="
              text-lg
              text-gray-600
              max-w-3xl
            "
          >
            Orion continues to evolve with
            new experiences for investors,
            traders and developers.
          </p>

        </div>

        <div
          className="
            grid
            lg:grid-cols-3
            gap-8
          "
        >

          {items.map((item) => {

            const Icon = item.icon;

            return (

              <div
                key={item.title}
                className="
                  bg-[#f8fafc]
                  rounded-[30px]
                  p-8
                  border
                  border-gray-100
                "
              >

                <div
                  className="
                    w-14
                    h-14
                    rounded-2xl

                    bg-blue-100
                    text-blue-700

                    flex
                    items-center
                    justify-center

                    mb-6
                  "
                >
                  <Icon size={28} />
                </div>

                <div
                  className="
                    inline-flex
                    items-center
                    gap-2

                    px-3
                    py-1

                    rounded-full

                    bg-amber-100
                    text-amber-700

                    text-xs
                    font-bold

                    mb-5
                  "
                >
                  <Sparkles size={14} />
                  COMING SOON
                </div>

                <h3
                  className="
                    text-2xl
                    font-black
                    mb-4
                  "
                >
                  {item.title}
                </h3>

                <p
                  className="
                    text-gray-600
                    leading-relaxed
                  "
                >
                  {item.description}
                </p>

              </div>

            );

          })}

        </div>

      </div>

    </section>
  );
};

export default SoftwareComingSoon;